module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payonline":"Here is the link to pay traffic ticket online.","paycash":"To pay in cash please go to the Circuit Clerk/ Traffic fines office."},"es":{"payonline":"Aquí está el enlace para pagar la multa de tráfico en línea.","paycash":"Para pagar en efectivo, por favor diríjase a la oficina del Secretario del Tribunal / multas de tráfico."}}')
  delete Component.options._Ctor
}
